// extracted by mini-css-extract-plugin
module.exports = {"system":"System_system__8nmbt"};